import { useSyncExternalStore } from "react";

export interface TransferCellPopoverTarget {
  /** The clicked cell element — popover anchor and outline host. */
  anchorEl: HTMLElement;
  sku: string;
  /** The spoke (destination) location. */
  spokeLocation: string;
  /** Source hub if the cell is hub-specific; null = all hubs for the cell. */
  sourceHub: string | null;
  /** Epoch ms of the clicked date column (the matrix period start). */
  periodStartMs: number;
  dateHierarchy: "day" | "week" | "month";
}

// Module-level store so matrix cells can open the popover without threading
// props (or state) through the table. Opening/closing re-renders ONLY the
// popover — the table's props never change, so react-virtuoso repaints zero
// cells. Mirrors the PO cell popover's isolation contract.
let currentTarget: TransferCellPopoverTarget | null = null;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openTransferCellPopover(
  target: TransferCellPopoverTarget
): void {
  currentTarget = target;
  emit();
}

export function closeTransferCellPopover(): void {
  if (currentTarget === null) return;
  currentTarget = null;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): TransferCellPopoverTarget | null {
  return currentTarget;
}

export function useTransferCellPopoverTarget(): TransferCellPopoverTarget | null {
  return useSyncExternalStore(subscribe, getSnapshot);
}
